export default "__VITE_ASSET__Br717V9C__"